import { render, staticRenderFns } from "./commonWebsiteDynamicManage.vue?vue&type=template&id=5d3cded0&scoped=true"
import script from "./commonWebsiteDynamicManage.vue?vue&type=script&lang=ts"
export * from "./commonWebsiteDynamicManage.vue?vue&type=script&lang=ts"
import style0 from "./commonWebsiteDynamicManage.vue?vue&type=style&index=0&id=5d3cded0&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3cded0",
  null
  
)

export default component.exports